// extracted by mini-css-extract-plugin
export default {"title":"FBVzOi","subtitle":"zHhBFr"};